import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { AfostoInstantSearchWidget } from '@afosto/instant-search-widget';
import '@afosto/instant-search-widget/dist/afosto-instant-search-widget.min.css';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import Layout from '../../../../components/Layout';
import Grid from '../../../../components/Grid';
import Typography from '../../../../components/Typography';
import Breadcrumbs from '../../../../components/Breadcrumbs';
import Button from '../../../../components/Button';
import Icon from '../../../../components/Icon';

const localizations = [
  {
    locale: 'en',
    slug: '/apps/instant-search/widget/',
  },
];

const demo = ({ location }) => {
  useEffect(() => {
    AfostoInstantSearchWidget.init('movies-demo');
  }, []);

  return (
    <Layout location={location} locale="nl-NL" localizations={localizations} slug="/nl/apps/instant-search/widget/">
      <Helmet
        title="Instant Search Widget | Afosto"
        meta={[
          {
            name: 'description',
            content: 'Verbeter je zoek functionaliteit met de makkelijk te integreren Instant Search Widget.',
          },
        ]}
      >
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/@afosto/instant-search-widget@latest/dist/afosto-instant-search-widget.min.css"
        />
        <html lang="nl" />
      </Helmet>
      <Breadcrumbs location={location} locale="nl" className="mt-24" wrapper={props => <Grid container {...props} />} />
      <Grid container className="pt-16 pb-120 d-flex flex-column align-items-center">
        <Typography variant="h1" className="mb-16 mt-32" align="center">
          Instant Search Widget
        </Typography>
        <Typography
          variant="subtitle-1"
          component="h2"
          weight="normal"
          className="mb-56 mt-16"
          align="center"
          color="text-secondary"
        >
          Klik op onderstaande knop om de widget te openen.
        </Typography>
        <Button data-af-instant-search size="lg">
          Start met zoeken
        </Button>

        <Typography variant="h2" className="mb-16 mt-120" align="center" color="text-primary">
          Hoe integreer je de widget?
        </Typography>
        <Typography
          variant="body-medium"
          component="h2"
          weight="normal"
          className="mb-56 mt-16"
          align="center"
          color="text-secondary"
        >
          De widget is open source en je kan de code en documentatie bekijken op de GitHub pagina.
          <br />
          Bijdragen om de widget te verbeteren worden ook zeer op prijs gesteld.
        </Typography>
        <Button
          color="afosto-dark"
          href="https://github.com/afosto/instant-search-widget"
          target="_blank"
          rel="noopener"
        >
          Open GitHub <Icon icon={faGithub} className="ml-8" />
        </Button>
      </Grid>
    </Layout>
  );
};

export default demo;
